import React from 'react';
import { Box, Paper, Typography, Tooltip } from '@mui/material';

function BadgeCard({ badge, earned = false }) {
  const rarityColors = {
    common: { bg: 'rgba(255, 255, 255, 0.1)', border: 'rgba(255, 255, 255, 0.2)' },
    rare: { bg: 'rgba(33, 150, 243, 0.2)', border: 'rgba(33, 150, 243, 0.5)' },
    epic: { bg: 'rgba(156, 39, 176, 0.2)', border: 'rgba(156, 39, 176, 0.5)' },
    legendary: { bg: 'rgba(255, 152, 0, 0.2)', border: 'rgba(255, 152, 0, 0.5)' }
  };

  const color = rarityColors[badge.rarity] || rarityColors.common;

  return (
    <Tooltip title={badge.description} arrow>
      <Paper
        sx={{
          p: 2,
          textAlign: 'center',
          backgroundColor: earned ? color.bg : 'rgba(255, 255, 255, 0.05)',
          border: `2px solid ${earned ? color.border : 'rgba(255, 255, 255, 0.1)'}`,
          borderRadius: 2,
          opacity: earned ? 1 : 0.5,
          transition: 'all 0.3s',
          cursor: 'pointer',
          '&:hover': {
            transform: earned ? 'translateY(-4px)' : 'none',
            boxShadow: earned ? 4 : 1
          },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {earned && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: 0,
              height: 0,
              borderStyle: 'solid',
              borderWidth: '0 30px 30px 0',
              borderColor: `transparent ${color.border} transparent transparent`,
              zIndex: 1
            }}
          />
        )}
        <Box
          sx={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            bgcolor: earned ? color.bg : 'rgba(255, 255, 255, 0.05)',
            border: `3px solid ${earned ? color.border : 'rgba(255, 255, 255, 0.2)'}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            mx: 'auto',
            filter: earned ? 'none' : 'grayscale(100%)',
            transition: 'all 0.3s',
            position: 'relative',
            overflow: 'hidden',
            '&::before': earned ? {
              content: '""',
              position: 'absolute',
              top: '-50%',
              left: '-50%',
              width: '200%',
              height: '200%',
              background: `radial-gradient(circle, ${color.border}40, transparent)`,
              animation: 'pulse 2s ease-in-out infinite',
              '@keyframes pulse': {
                '0%, 100%': { opacity: 0.3 },
                '50%': { opacity: 0.6 }
              }
            } : {}
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: '3rem',
              lineHeight: 1,
              filter: earned ? 'drop-shadow(0 0 8px rgba(255,255,255,0.5))' : 'none'
            }}
          >
            {badge.icon || '🏅'}
          </Typography>
        </Box>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: earned ? 'text.primary' : 'text.secondary',
            mb: 0.5
          }}
        >
          {badge.name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: earned ? color.border : 'text.disabled',
            textTransform: 'uppercase',
            fontSize: '0.7rem'
          }}
        >
          {badge.rarity}
        </Typography>
      </Paper>
    </Tooltip>
  );
}

export default BadgeCard;
